import { Component, OnInit } from '@angular/core';
import { TranslateService } from './core/services/translate.service';
import { LoggerService } from './core/services/logger.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  constructor(private translate: TranslateService, private _logger:LoggerService, private router: Router) {
    translate.use('en').then(() => {
    });
    
  }
  ngOnInit(){
    this._logger.logDevice();
    var version = this.detectIE();
    if(version != false){
      this.router.navigate(['/ie']);
    }
  }

  detectIE(){
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    
  }
  // other browser
  return false;
  }
}
